export var VELT_SDK_VERSION = '4.7.0';
export var VELT_SDK_INIT_EVENT = 'onVeltInit';
export var VELT_TAB_ID = 'veltTabId';
// integrity map for the Velt SDK
// Note: generate integrity hashes with: https://www.srihash.org/
export var INTEGRITY_MAP = {
    '4.7.0': 'sha384-OY0d1wWgh2IUn8TjXdfHKw8kIq0jEbRo4mQdZ+hwcnhgzWROKDi0CJjl+95rO40d',
};
